'use strict';

export default class Accordion {
  constructor() {
    let accordions = $('.accordion');
    let self = this;
    accordions.each(function(k,v) {
      self.initAccordion($(v));
    })
  }

  initAccordion($el) {
    $el.on("click",".accordion_trigger", function(e) {
      let parentItem =  $(this).closest('.accordion_item');
      let otherItem = $el.find(".accordion_item").not(parentItem);
      // otherItem.removeClass('active');
      // otherItem.find(".accordion_content").slideUp('slow');
      parentItem.toggleClass("active");
      parentItem.find(".accordion_content").slideToggle();
    });
  } 
}
